import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { Formik } from "formik";
import CancelSaveBtns from "../buttons/cancelSaveBtns";
import {
  Delete,
  deleteInit,
  deleteValidationSchema,
} from "../../dtos/delete.dtos";

interface IProps {
  onDelete: (value: any) => void;
  open: boolean;
  onClose: () => void;
  value: any;
}

const DeleteDialog: React.FC<IProps> = ({ open, onClose, onDelete, value }) => {
  const [init] = useState<Delete>(deleteInit);
  return (
    <Formik
      initialValues={init}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={deleteValidationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);

        onDelete(value);
      }}
      enableReinitialize={true}
    >
      {(props) => {
        const {
          values,
          errors,
          touched,
          isSubmitting,
          handleBlur,
          handleChange,
          handleSubmit,
        } = props;
        return (
          <Dialog open={true}>
            <DialogTitle>
              <Typography variant="h6">Delete</Typography>
              <Typography variant="subtitle2">
                Are you sure you want to Delete?
              </Typography>
            </DialogTitle>
            <DialogContent>
              <form onSubmit={handleSubmit} noValidate>
                <Typography variant="subtitle2">
                  Type DELETE to confirm
                </Typography>
                <TextField
                  variant="outlined"
                  size="small"
                  margin="none"
                  value={values.delete}
                  name="delete"
                  onChange={handleChange}
                  onBlur={(e) => {
                    handleBlur(e);
                  }}
                  error={Boolean(errors.delete && touched.delete)}
                  helperText={
                    Boolean(errors.delete) && touched.delete && errors.delete
                  }
                  fullWidth
                  required
                />

                <CancelSaveBtns
                  isSubmitting={isSubmitting}
                  onClose={onClose}
                  saveText="Delete"
                  open={open}
                />
              </form>
            </DialogContent>
          </Dialog>
        );
      }}
    </Formik>
  );
};

export default DeleteDialog;
